import api from '../common/api/channelApi';
import generalApi from '../common/api';

const basePath = '/channels';

export default {
  getList(params = {}) {
    return api.get(basePath, { params });
  },
  getGeneralList(params = {}) {
    return generalApi.get('/mediaItems/filters', { params });
  },
  create(channel) {
    return api.post(`${basePath}`, channel);
  },
  get(channelId, params = {}) {
    return api.get(`${basePath}/${channelId}`, { params });
  },
  update(channelId, channel) {
    return api.put(`${basePath}/${channelId}`, channel);
  }
};



// WEBPACK FOOTER //
// ./src/services/channelService.js